import { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Typography, TextField, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion'

export default function ContactForm({ isInView }) {

    const [state, handleSubmit] = useForm("xknlrqbp");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");

    if (state.succeeded) {
        return <Typography
            sx={{ m: 3 }}
            align="center"
            color="secondary">
            Thanks for reaching out! I'll get back to you as soon as I can.
        </Typography>;
    }

    return (
        <Grid container

            sx={{ display: 'flex', justifyContent: 'center' }}>
            <form onSubmit={handleSubmit}>
                <Grid item
                    component={motion.div}
                    sx={{ my: 2, display: 'flex', justifyContent: 'center' }}
                    initial={{ opacity: 0 }}
                    transition={{ delay: 0.7, duration: 1 }}
                    animate={isInView ? { opacity: 1 } : "none"}
                >
                    <TextField
                        color="secondary"
                        label="Your Email"
                        required
                        id="email"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                    />
                </Grid>
                <Grid item
                    component={motion.div}
                    sx={{ my: 2, display: 'flex', justifyContent: 'center' }}
                    initial={{ opacity: 0 }}
                    transition={{ delay: 0.9, duration: 1 }}
                    animate={isInView ? { opacity: 1 } : "none"}
                >
                    <TextField
                        color="secondary"
                        label="Your Name"
                        required
                        id="name"
                        type="text"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <ValidationError
                        prefix="Name"
                        field="name"
                        errors={state.errors}
                    />
                </Grid>
                <Grid item
                    component={motion.div}
                    sx={{ my: 2 }}
                    initial={{ opacity: 0 }}
                    transition={{ delay: 1.1, duration: 1 }}
                    animate={isInView ? { opacity: 1 } : "none"}>
                    <TextField
                        color="secondary"
                        sx={{
                            width: {
                                xs: 225,
                                sm: 300,
                            }
                        }}
                        multiline
                        rows="5"
                        label="Your Message"
                        required
                        id="message"
                        name="message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                </Grid>
                <Grid item
                    component={motion.div}
                    sx={{ my: 2, display: 'flex', justifyContent: 'center' }}
                    initial={{ opacity: 0 }}
                    transition={{ delay: 0.5, duration: 1 }}
                    animate={isInView ? { opacity: 1 } : "none"}
                >
                    <Button
                        component={motion.button}
                        whileHover={{ scale: 1.2 }}
                        variant="outlined"
                        size="large"
                        type="submit"
                        disabled={state.submitting}>
                        Submit
                    </Button>
                </Grid>
            </form>
        </Grid>
    );
}